import UpdateActions from './update/components/UpdateActions';

import LocationHeaderEditor from "./location/components/LocationHeaderEditor";
import LocationHeaderViewer from "./location/components/LocationHeaderViewer";

import DashView from "./dashboard/components/DashView";
import DashViewRow from "./dashboard/components/DashViewRow";
import DashViewByGroup from "./dashboard/components/DashViewByGroup";
import DashViewByGroupRow from "./dashboard/components/DashViewByGroupRow";
import DashShortCuts from "./dashboard/components/DashShortCuts";
import DashSCRow from "./dashboard/components/DashSCRow";
import DashGroupChoice from "./dashboard/components/DashGroupChoice";

import AlarmOwner from "./alarm/components/AlarmOwner";
import AlarmHeaderViewer from "./alarm/components/AlarmHeaderViewer";
import AlarmHeaderEditor from "./alarm/components/AlarmHeaderEditor";
import AlarmCriteria from "./alarm/components/AlarmCriteria";

import RoleDocumentRow from "./role/components/RoleDocumentRow";
import RoleHeaderViewer from "./role/components/RoleHeaderViewer";
import RoleHeaderEditor from "./role/components/RoleHeaderEditor";
import RolePermTag from "./role/components/RolePermTag";
import RolePrivilegeRow from "./role/components/RolePrivilegeRow";
import RolePrivilegeEditor from "./role/components/RolePrivilegeEditor";

import UserHeaderViewer from "./user/components/UserHeaderViewer";
import UserHeaderEditor from "./user/components/UserHeaderEditor";
import UserHeaderLimitedEditor from "./user/components/UserHeaderLimitedEditor";
import UserHeaderLimitedViewer from "./user/components/UserHeaderLimitedViewer";

import UserRole from "./user/components/UserRole";
import UserCompany from "./user/components/UserCompany";
import UserLocation from "./user/components/UserLocation";
import UserDevice from "./user/components/UserDevice";
import UserDeviceRow from "./user/components/UserDeviceRow";
import UserDeviceEditor from "./user/components/UserDeviceEditor";

import cmnViewMap from '../cmn/Index';
import taskIndex from "../project/Index"

import CurrencyHeaderEditor from "./currency/components/CurrencyHeaderEditor";
import CurrencyHeaderViewer from "./currency/components/CurrencyHeaderViewer";

import WorkFlowHeader from "./workflow/components/WorkFlowHeader";
import WorkFlowEditor from "./workflow/components/WorkFlowEditor";
import WorkFlowEditorRow from "./workflow/components/WorkFlowEditorRow";
import WorkFlowPlanCriteriaEditor from "./workflow/components/WorkFlowPlanCriteriaEditor";
import WorkFlowPlanCriteriaRow from "./workflow/components/WorkFlowPlanCriteriaRow";

import ListChoices from './list/components/ListChoices'; 
import ListChoiceSearch from './list/components/ListChoiceSearch';
import ListChoicesRow from './list/components/ListChoicesRow';
import ListHeader from "./list/components/ListHeader";

import ItemShorthand from '../item/item/components/ItemShorthand';
import ProfileShorthand from "../profile/components/ProfileShorthand";
import CategoryMasterSH from './category/components/CategoryMasterSH';
import CategoryDetailSH from './category/components/CategoryDetailSH';

import DirectPrint from './printers/DirectPrint';
import itemIndex from "../item/Index";
import ProdJOTaskDashRow from '../project/production/order/components/ProdJOTaskDashRow';
import ProdJOTaskMini from '../project/production/order/components/ProdJOTaskMini';
import TaskDashRow from '../project/task/components/TaskDashRow';
import TaskDashImageRow from '../project/task/components/TaskDashImageRow';

const systemViewMap = {
    "dbActions": UpdateActions,
    "vLocationHeaderEditor":LocationHeaderEditor,
    "vLocationHeaderViewer":LocationHeaderViewer,

    "vDashView":DashView,
    "vDashViewRow":DashViewRow,

    "vDashViewByGroup":DashViewByGroup,
    "vDashViewByGroupRow":DashViewByGroupRow,
    "vDashShortCuts":DashShortCuts,
    "vDashSCRow":DashSCRow,
    "vDashGroupChoice":DashGroupChoice,

    "vAlarmHeaderViewer":AlarmHeaderViewer,
    "vAlarmHeaderEditor":AlarmHeaderEditor,
    "vAlarmOwner":AlarmOwner,
    "vAlarmCriteria":AlarmCriteria,

    "vRoleDocumentRow":RoleDocumentRow,
    "vRoleHeaderViewer":RoleHeaderViewer,
    "vRoleHeaderEditor":RoleHeaderEditor,
    "vRolePermTag":RolePermTag,
    "vRolePrivilegeRow":RolePrivilegeRow,
    "vPrivilegeEditor":RolePrivilegeEditor,

    "vUserHeaderViewer":UserHeaderViewer,
    "vUserHeaderEditor":UserHeaderEditor,
    "vUserHeaderLViewer":UserHeaderLimitedViewer,
    "vUserHeaderLEditor":UserHeaderLimitedEditor,
    "vUserRole":UserRole,
    "vUserCompany":UserCompany,
    "vUserLocation":UserLocation,
    "vUserDevice":UserDevice,
    "vUserDeviceRow":UserDeviceRow,
    "vUserDeviceEditor":UserDeviceEditor,

    "vCurrencyHeaderEditor":CurrencyHeaderEditor,
    "vCurrencyHeaderViewer":CurrencyHeaderViewer,

    "vWorkFlowHeader":WorkFlowHeader,
    "vWorkFlowEditor":WorkFlowEditor,
    "vWorkFlowEditorRow":WorkFlowEditorRow,
    "vWorkFlowRowEditor":WorkFlowEditorRow,
    "vWorkFlowPlanCriteriaEditor":WorkFlowPlanCriteriaEditor,
    "vWorkFlowPlanCriteriaRow":WorkFlowPlanCriteriaRow,

    "vListChoices": ListChoices,
    "vListChoicesRow": ListChoicesRow,
    "vListChoiceSearch": ListChoiceSearch,
    "vListHeader": ListHeader,

    "vCatMasterSH": CategoryMasterSH,
    "vCatDetailSH": CategoryDetailSH,
    "vProShorthand": ProfileShorthand,
    "vItemShorthand": ItemShorthand,

    "vDirectPrint": DirectPrint,

    "vJOTaskDashRow":ProdJOTaskDashRow,
    "vJOTaskMini":ProdJOTaskMini,
    "vTaskDashRow":TaskDashRow,
    "vTaskDashImageRow":TaskDashImageRow,

    ...cmnViewMap,
    ...taskIndex,
    ...itemIndex
}

export default systemViewMap;
